"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditablePageContent = void 0;
const MarkdownStyle_1 = require("@juvare/common-web-ui/MarkdownStyle");
const marked_1 = require("marked");
const react_1 = __importDefault(require("react"));
const EditablePageContent = (props) => {
    return (react_1.default.createElement(MarkdownStyle_1.MarkdownStyle, { ...props },
        react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: (0, marked_1.marked)(props.page.content) } })));
};
exports.EditablePageContent = EditablePageContent;
